export default () => {

  var maxMobileSize = 1040;
  var windowWidth = window.innerWidth;
  var isTablet;


  //isMobile initialization:
  if (windowWidth < maxMobileSize) {
    isTablet = true;
    owlInit();
  } else {
    isTablet = false;
    owlDestroy();
  }

  //Window resize event:
  $(window).resize(function () {
    windowWidth = window.innerWidth;

    if (windowWidth < maxMobileSize && !isTablet) {
      isTablet = true;
      owlInit();
    } else if (windowWidth >= maxMobileSize && isTablet) {
      isTablet = false;
      owlDestroy();
    }
  });

  window.onload = function () {
    const url = location.pathname;
    let regex = '';

    if (url === null || url === undefined) {
      return ;
    }

    if (url === '/') {
      // Si estamos en la home, geeramos el regex  de home
      regex = `^http[s]?\\:\\/\\/${location.hostname}(\\/)?$`;
    } else {
      regex = `^http.*(\.es|\.com|\.test|\:8000)${url.replaceAll('/', '\\/')}$`;
    }
    const navs = document.getElementsByClassName('htags');

    const regexBasePath = regex.replace(/([^\/]*(_\d+){2}\.html)/, '');

    Array.from(navs).forEach((element) => {
      let urls = element.getElementsByTagName('a');
      Array.from(urls).forEach((el) => {

        if ( el.href.match(regex) && (el.getAttribute("href").trim().length > 1)) {
            el.classList.add('activecategory');
            if (el.closest('.item-dropdown')) {
                var elParent = el.closest('.item-dropdown');
                elParent.previousElementSibling.className = 'activecategory';
            }
        } else if ((el.href.match(regex) || el.href.match(regexBasePath)) && (el.getAttribute("href").trim().length > 1)) {
            el.classList.add('activecategory');
            if (el.closest('.item-dropdown')) {
                var elParent = el.closest('.item-dropdown');
                elParent.previousElementSibling.className = 'activecategory';
            }
        }

      });
    });
  }


  function owlDestroy() {
    $('.owl-htags').owlCarousel('destroy');
  }


  function owlInit() {

    $('.owl-htags').owlCarousel({
      margin: 20,
      loop: false,
      dots: false,
      nav: false,
      autoWidth: true,
      items: 4
    });

  }
}
